import React from 'react';
import LoginHeader from '../LoginHeader';

export default ({ children })=> (
	<div className='LoginPage'>
		<LoginHeader/>
		{ children }
	</div>
);